import {useEffect, useRef, useState} from 'react'

import noop from 'lodash/noop'

export default (timeout: number, active: boolean, onTimeout: () => void = noop) => {
  const [timedOut, setTimedOut] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout>(null)

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (timeout > 0 && active) {
      timeoutRef.current = setTimeout(() => {
        setTimedOut(true)
        onTimeout()
      }, timeout)
    }

    if (!active) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      setTimedOut(false)
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [timeout, active])

  return timedOut
}
